export default __webpack_public_path__ + "static/media/online-payment.2a616786.svg";